/* @flow */
import cx from 'classnames';
import React from 'react';

import { getPropClassesFromInstance } from 'lib/getPropClasses';
import Legend from 'components/Legend.jsx';

import './styles/Fieldset.scss';

class Fieldset extends React.Component {
  static propTypes = {
    legend: React.PropTypes.string,
    size: React.PropTypes.oneOf(['small']),
  };

  static propClasses = {
    size: {
      small: 'Fieldset-small',
    },
  };

  renderLegend = () => {
    const { legend } = this.props;
    if (!legend) {
      return null;
    }
    return <Legend text={legend} />;
  };

  render() {
    const legend = this.renderLegend();

    // renders `div` instead of `fieldset` to not require `form` wrapper
    // https://bugs.chromium.org/p/chromium/issues/detail?id=570095#c22
    return (
      <div
        className={cx(
          'Fieldset',
          getPropClassesFromInstance(this),
          this.props.className
        )}>
        {legend}
        {this.props.children}
      </div>
    );
  }
}

export default Fieldset;



// WEBPACK FOOTER //
// ./src/components/Fieldset.jsx